export default __webpack_public_path__ + "static/media/gls.a657dc25.svg";